var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconButget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budget_w62dzusq9bxv 1",
    clipPath: "url(#clip0_16_1031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0835 2.91669H1.66683C1.16683 2.91669 0.833496 3.25002 0.833496 3.75002V8.33335V24.5834C0.833496 24.8334 1.00016 25 1.25016 25H17.5002C17.7502 25 17.9168 24.8334 17.9168 24.5834V8.33335V3.75002C17.9168 3.25002 17.5835 2.91669 17.0835 2.91669ZM1.66683 3.75002H17.0835V7.91669H1.66683V3.75002ZM17.0835 24.1667H1.66683V8.75002H17.0835V24.1667Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 5.41669H3.75V6.25002H8.75V5.41669Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0833 5.41669H10V6.25002H12.0833V5.41669Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.41683 10H3.3335V10.8333H5.41683V10Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.75033 10H6.66699V10.8333H8.75033V10Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.0833 10H10V10.8333H12.0833V10Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.4168 10H13.3335V10.8333H15.4168V10Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.33366 15H6.25033C6.50033 15 6.66699 14.8333 6.66699 14.5833V12.5C6.66699 12.25 6.50033 12.0833 6.25033 12.0833H3.33366C3.08366 12.0833 2.91699 12.25 2.91699 12.5V14.5833C2.91699 14.8333 3.08366 15 3.33366 15ZM3.75033 12.9166H5.83366V14.1666H3.75033V12.9166Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.8333 12.0833H7.91667C7.66667 12.0833 7.5 12.25 7.5 12.5V14.5833C7.5 14.8333 7.66667 15 7.91667 15H10.8333C11.0833 15 11.25 14.8333 11.25 14.5833V12.5C11.25 12.25 11.0833 12.0833 10.8333 12.0833ZM10.4167 14.1666H8.33333V12.9166H10.4167V14.1666Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.0835 14.5833C12.0835 14.8333 12.2502 15 12.5002 15H15.4168C15.6668 15 15.8335 14.8333 15.8335 14.5833V12.5C15.8335 12.25 15.6668 12.0833 15.4168 12.0833H12.5002C12.2502 12.0833 12.0835 12.25 12.0835 12.5V14.5833ZM12.9168 12.9166H15.0002V14.1666H12.9168V12.9166Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M3.33366 19.1667H6.25033C6.50033 19.1667 6.66699 19 6.66699 18.75V16.6667C6.66699 16.4167 6.50033 16.25 6.25033 16.25H3.33366C3.08366 16.25 2.91699 16.4167 2.91699 16.6667V18.75C2.91699 19 3.08366 19.1667 3.33366 19.1667ZM3.75033 17.0833H5.83366V18.3333H3.75033V17.0833Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.8333 16.25H7.91667C7.66667 16.25 7.5 16.4167 7.5 16.6667V18.75C7.5 19 7.66667 19.1667 7.91667 19.1667H10.8333C11.0833 19.1667 11.25 19 11.25 18.75V16.6667C11.25 16.4167 11.0833 16.25 10.8333 16.25ZM10.4167 18.3333H8.33333V17.0833H10.4167V18.3333Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M15.4168 16.25H12.5002C12.2502 16.25 12.0835 16.4167 12.0835 16.6667V18.75C12.0835 19 12.2502 19.1667 12.5002 19.1667H15.4168C15.6668 19.1667 15.8335 19 15.8335 18.75V16.6667C15.8335 16.4167 15.6668 16.25 15.4168 16.25ZM15.0002 18.3333H12.9168V17.0833H15.0002V18.3333Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M3.33366 23.3334H6.25033C6.50033 23.3334 6.66699 23.1667 6.66699 22.9167V20.8334C6.66699 20.5834 6.50033 20.4167 6.25033 20.4167H3.33366C3.08366 20.4167 2.91699 20.5834 2.91699 20.8334V22.9167C2.91699 23.1667 3.08366 23.3334 3.33366 23.3334ZM3.75033 21.25H5.83366V22.5H3.75033V21.25Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10.8333 20.4167H7.91667C7.66667 20.4167 7.5 20.5834 7.5 20.8334V22.9167C7.5 23.1667 7.66667 23.3334 7.91667 23.3334H10.8333C11.0833 23.3334 11.25 23.1667 11.25 22.9167V20.8334C11.25 20.5834 11.0833 20.4167 10.8333 20.4167ZM10.4167 22.5H8.33333V21.25H10.4167V22.5Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M15.4168 20.4167H12.5002C12.2502 20.4167 12.0835 20.5834 12.0835 20.8334V22.9167C12.0835 23.1667 12.2502 23.3334 12.5002 23.3334H15.4168C15.6668 23.3334 15.8335 23.1667 15.8335 22.9167V20.8334C15.8335 20.5834 15.6668 20.4167 15.4168 20.4167ZM15.0002 22.5H12.9168V21.25H15.0002V22.5Z",
    fill: "#5F6C72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M23.3337 10V22.0833H22.5003V20V4.16667C22.5003 4.08333 22.4587 3.95833 22.417 3.91667L21.2087 0.291667C21.167 0.125 21.0003 0 20.8337 0C20.667 0 20.5003 0.125 20.4587 0.291667L19.2503 3.91667C19.2087 4 19.167 4.08333 19.167 4.16667V20V24.5833C19.167 24.8333 19.3337 25 19.5837 25H22.0837C22.3337 25 22.5003 24.8333 22.5003 24.5833V22.9167H23.7503C24.0003 22.9167 24.167 22.75 24.167 22.5V10H23.3337ZM20.0003 4.58333H21.667V19.5833H20.0003V4.58333ZM20.8337 1.75L21.5003 3.75H20.167L20.8337 1.75ZM21.667 24.1667H20.0003V20.4167H21.667V24.1667Z",
    fill: "#5F6C72"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_1031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButget);
export default __webpack_public_path__ + "static/media/icon-butget.95e8042389fc6637af25f3568dcdb1fa.svg";
export { ForwardRef as ReactComponent };